import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import buscarTodasAdesoesPontos from '../../actions/adesao-pontos/buscarTodasAdesoesPontos';
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN } from '../../security/securityContext';
import AdesaoPonto from './AdesaoPonto';


export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col">Empresa</div>
            <div className="col">Peso</div>
            <div className="col">Pontos</div>
            <div className="col ml-md-2">Ativar/Inativar para Geração de Pontos</div>
            <div className="col">Ativar/Inativar para Consumo de Pontos</div>
            <div className="col-sm-2 d-flex justify-content-center">Ações</div>
        </div>
    </div>
);

export class PainelGerenciarAdesaoPontos extends Component {

    componentDidMount() {
        this.props.buscarTodasAdesoesPontos();

    }

    exibirAdesaoPontos() {
        if (!this.props.adesaoPontos || this.props.adesaoPontos.length == 0) {
            return <div>Nenhum agendamento de viagem.</div>;
        }

        return this.props.adesaoPontos.map(it =>
            <AdesaoPonto  key={`adesao-pontos-${it.id}`} adesaoPonto={it} /> );
    }

    exibirTabelaAdesaoPontos() {
        return (<div className="col-12 conteudo-internas">
            {this.props.adesaoPontos && this.props.adesaoPontos.length != 0 && <CabecalhoTabela />}
            <div className="lista-table">
                {this.exibirAdesaoPontos()}
            </div>
        </div>
        )
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div>
                    <div className='col-md-12'>
                        <Titulo texto="Painel Adesão de Pontos" urlRetorno="/menu-adesao-pontos" />
                    </div>
                    
                    {this.exibirTabelaAdesaoPontos()}
                </div>
            </Autorizacao>
        )
    }
}

export function mapStateToProps(state) {
    return {
        adesaoPontos: state.adesaoPontos,
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication
    }
}

export default withRouter(connect(mapStateToProps, {
        buscarTodasAdesoesPontos
    }
)(PainelGerenciarAdesaoPontos));


